import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shop-page" }
const _hoisted_2 = { class: "hero-banner" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-countdown" }
const _hoisted_5 = { class: "countdown-timer" }
const _hoisted_6 = { class: "time-block" }
const _hoisted_7 = { class: "time-value" }
const _hoisted_8 = { class: "time-block" }
const _hoisted_9 = { class: "time-value" }
const _hoisted_10 = { class: "time-block" }
const _hoisted_11 = { class: "time-value" }
const _hoisted_12 = { class: "time-block" }
const _hoisted_13 = { class: "time-value" }
const _hoisted_14 = { class: "category-nav" }
const _hoisted_15 = { class: "category-wrapper" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "category-name" }
const _hoisted_19 = { class: "time-deal-section" }
const _hoisted_20 = { class: "section-header" }
const _hoisted_21 = { class: "section-title-wrapper" }
const _hoisted_22 = { class: "time-deal-grid" }
const _hoisted_23 = { class: "deal-badge" }
const _hoisted_24 = { class: "product-image" }
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "product-info" }
const _hoisted_27 = { class: "product-name" }
const _hoisted_28 = { class: "product-desc" }
const _hoisted_29 = { class: "price-wrapper" }
const _hoisted_30 = { class: "original-price" }
const _hoisted_31 = { class: "sale-price" }
const _hoisted_32 = { class: "deal-progress" }
const _hoisted_33 = { class: "progress-bar" }
const _hoisted_34 = { class: "sold-text" }
const _hoisted_35 = { class: "best-section" }
const _hoisted_36 = { class: "product-grid" }
const _hoisted_37 = { class: "rank-badge" }
const _hoisted_38 = { class: "product-image-wrapper" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "product-tags" }
const _hoisted_41 = {
  key: 0,
  class: "tag tag-new"
}
const _hoisted_42 = {
  key: 1,
  class: "tag tag-best"
}
const _hoisted_43 = {
  key: 2,
  class: "tag tag-sale"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "product-content" }
const _hoisted_46 = { class: "product-brand" }
const _hoisted_47 = { class: "product-name" }
const _hoisted_48 = { class: "product-rating" }
const _hoisted_49 = { class: "stars" }
const _hoisted_50 = { class: "review-count" }
const _hoisted_51 = { class: "product-price" }
const _hoisted_52 = {
  key: 0,
  class: "original-price"
}
const _hoisted_53 = { class: "current-price" }
const _hoisted_54 = { class: "product-benefits" }
const _hoisted_55 = {
  key: 0,
  class: "benefit-tag"
}
const _hoisted_56 = {
  key: 1,
  class: "benefit-tag"
}
const _hoisted_57 = { class: "gift-section" }
const _hoisted_58 = { class: "gift-grid" }
const _hoisted_59 = { class: "gift-image" }
const _hoisted_60 = ["src", "alt"]
const _hoisted_61 = { class: "gift-info" }
const _hoisted_62 = { class: "gift-name" }
const _hoisted_63 = { class: "gift-desc" }
const _hoisted_64 = { class: "gift-price" }
const _hoisted_65 = { class: "gift-includes" }
const _hoisted_66 = { class: "recommend-section" }
const _hoisted_67 = { class: "recommend-grid" }
const _hoisted_68 = { class: "recommend-image" }
const _hoisted_69 = ["src", "alt"]
const _hoisted_70 = {
  key: 0,
  class: "discount-badge"
}
const _hoisted_71 = { class: "recommend-info" }
const _hoisted_72 = { class: "recommend-name" }
const _hoisted_73 = { class: "recommend-price" }
const _hoisted_74 = { class: "sale" }
const _hoisted_75 = {
  key: 0,
  class: "original"
}
const _hoisted_76 = { class: "recommend-tags" }
const _hoisted_77 = { class: "review-section" }
const _hoisted_78 = { class: "review-grid" }
const _hoisted_79 = { class: "review-header" }
const _hoisted_80 = ["src", "alt"]
const _hoisted_81 = { class: "reviewer-info" }
const _hoisted_82 = { class: "reviewer-name" }
const _hoisted_83 = { class: "review-date" }
const _hoisted_84 = { class: "review-rating" }
const _hoisted_85 = { class: "review-product" }
const _hoisted_86 = { class: "review-content" }
const _hoisted_87 = { class: "review-helpful" }
const _hoisted_88 = { class: "bottom-banner" }
const _hoisted_89 = { class: "banner-content" }
const _hoisted_90 = ["src", "alt"]
const _hoisted_91 = { class: "cart-item-info" }
const _hoisted_92 = { class: "cart-item-name" }
const _hoisted_93 = { class: "cart-item-price" }
const _hoisted_94 = { class: "cart-item-quantity" }
const _hoisted_95 = { class: "quantity" }
const _hoisted_96 = { class: "cart-total" }
const _hoisted_97 = { class: "total-price" }

import { ref, computed, onMounted, onUnmounted } from 'vue';

// 타입 정의
interface Product {
  id: number;
  name: string;
  description?: string;
  image: string;
  brand?: string;
  originalPrice: number;
  salePrice: number;
  discount: number;
  rating?: number;
  reviews?: number;
  soldPercent?: number;
  isNew?: boolean;
  isBest?: boolean;
  isWishlisted?: boolean;
  freeShipping?: boolean;
  giftAvailable?: boolean;
  todayDelivery?: boolean;
  quantity?: number;
  includes?: string[];
  price?: number;
}

interface Review {
  id: number;
  name: string;
  avatar: string;
  date: string;
  rating: number;
  product: string;
  content: string;
  helpful: number;
}

interface Category {
  id: string;
  name: string;
  icon: string;
}

// 카운트다운 상태

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminShop',
  setup(__props) {

const countdown = ref({
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00'
});

let countdownInterval: number | null = null;

// 카운트다운 계산
const updateCountdown = () => {
  const targetDate = new Date('2025-01-28T00:00:00');
  const now = new Date();
  const diff = targetDate.getTime() - now.getTime();
  
  if (diff > 0) {
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    countdown.value = {
      days: String(days).padStart(2, '0'),
      hours: String(hours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0')
    };
  }
};

// 카테고리 (실제 이미지 사용)
const categories = ref<Category[]>([
  { id: 'all', name: '전체', icon: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&h=100&fit=crop' },
  { id: 'container', name: '반찬통', icon: 'https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=100&h=100&fit=crop' },
  { id: 'kitchen', name: '주방용품', icon: 'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=100&h=100&fit=crop' },
  { id: 'living', name: '생활용품', icon: 'https://images.unsplash.com/photo-1583947215259-38e31be8751f?w=100&h=100&fit=crop' },
  { id: 'gift', name: '선물세트', icon: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=100&h=100&fit=crop' },
  { id: 'food', name: '식품', icon: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=100&h=100&fit=crop' }
]);

const selectedCategory = ref('all');

// 타임딜 상품 (실제 이미지 사용)
const timeDealProducts = ref<Product[]>([
  {
    id: 1,
    name: '프리미엄 스텐 반찬통 10종세트',
    description: '누수방지 밀폐력 UP!',
    image: 'https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=400&h=400&fit=crop',
    originalPrice: 89000,
    salePrice: 44500,
    discount: 50,
    soldPercent: 87
  },
  {
    id: 2,
    name: '인덕션 냄비세트 4종',
    description: '독일산 코팅, 5년보증',
    image: 'https://images.unsplash.com/photo-1584990347449-a5e5e800b678?w=400&h=400&fit=crop',
    originalPrice: 159000,
    salePrice: 79500,
    discount: 50,
    soldPercent: 72
  },
  {
    id: 3,
    name: '에어프라이어 12L 대용량',
    description: '360도 열풍순환',
    image: 'https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop',
    originalPrice: 199000,
    salePrice: 119400,
    discount: 40,
    soldPercent: 95
  }
]);

// 베스트셀러 상품 (실제 이미지 사용)
const bestProducts = ref<Product[]>([
  {
    id: 4,
    name: '락앤락 반찬통 풀세트 32p',
    brand: '락앤락',
    image: 'https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=300&h=300&fit=crop',
    originalPrice: 128000,
    salePrice: 89600,
    discount: 30,
    rating: 5,
    reviews: 2847,
    isNew: false,
    isBest: true,
    isWishlisted: false,
    freeShipping: true,
    giftAvailable: true
  },
  {
    id: 5,
    name: '테팔 프라이팬 3종세트',
    brand: '테팔',
    image: 'https://images.unsplash.com/photo-1592154395949-9d07e4a44e09?w=300&h=300&fit=crop',
    originalPrice: 89000,
    salePrice: 62300,
    discount: 30,
    rating: 5,
    reviews: 1923,
    isNew: true,
    isBest: true,
    isWishlisted: false,
    freeShipping: true,
    giftAvailable: false
  },
  {
    id: 6,
    name: '스텐 믹싱볼 5종 + 채반세트',
    brand: '키친아트',
    image: 'https://images.unsplash.com/photo-1590794056226-79ef3a8147e1?w=300&h=300&fit=crop',
    originalPrice: 45000,
    salePrice: 27000,
    discount: 40,
    rating: 4,
    reviews: 892,
    isNew: false,
    isBest: false,
    isWishlisted: true,
    freeShipping: true,
    giftAvailable: false
  },
  {
    id: 7,
    name: '실리콘 주방장갑 2세트',
    brand: '실리만',
    image: 'https://images.unsplash.com/photo-1591261730799-ee4e6c2d16d7?w=300&h=300&fit=crop',
    originalPrice: 28000,
    salePrice: 16800,
    discount: 40,
    rating: 5,
    reviews: 3421,
    isNew: false,
    isBest: true,
    isWishlisted: false,
    freeShipping: true,
    giftAvailable: false
  },
  {
    id: 8,
    name: '전자레인지 용기세트 20p',
    brand: '글라스락',
    image: 'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=300&h=300&fit=crop',
    originalPrice: 79000,
    salePrice: 47400,
    discount: 40,
    rating: 4,
    reviews: 1256,
    isNew: true,
    isBest: false,
    isWishlisted: false,
    freeShipping: true,
    giftAvailable: true
  },
  {
    id: 9,
    name: '주방 정리선반 3단',
    brand: '리빙박스',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop',
    originalPrice: 55000,
    salePrice: 38500,
    discount: 30,
    rating: 4,
    reviews: 678,
    isNew: false,
    isBest: false,
    isWishlisted: false,
    freeShipping: true,
    giftAvailable: false
  }
]);

// 선물세트 (실제 이미지 사용)
const giftSets = ref<Product[]>([
  {
    id: 10,
    name: '설날 효도선물 세트 A',
    description: '부모님께 드리는 건강한 선물',
    image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=400&h=400&fit=crop',
    price: 89000,
    originalPrice: 89000,
    salePrice: 89000,
    discount: 0,
    includes: ['홍삼정 1박스', '꿀 선물세트', '한과 모음']
  },
  {
    id: 11,
    name: '새댁 주방선물 세트',
    description: '신혼집에 딱 맞는 구성',
    image: 'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=400&h=400&fit=crop',
    price: 129000,
    originalPrice: 129000,
    salePrice: 129000,
    discount: 0,
    includes: ['프라이팬 세트', '냄비 세트', '조리도구 세트']
  },
  {
    id: 12,
    name: '프리미엄 반찬통 선물세트',
    description: '실용적인 선물의 정석',
    image: 'https://images.unsplash.com/photo-1607532941433-304659e8198a?w=400&h=400&fit=crop',
    price: 79000,
    originalPrice: 79000,
    salePrice: 79000,
    discount: 0,
    includes: ['스텐 반찬통 20p', '밀폐용기 10p', '정리 파우치']
  }
]);

// 추천 상품 (실제 이미지 사용)
const recommendProducts = ref<Product[]>([
  { id: 13, name: '만능 채칼 세트', image: 'https://images.unsplash.com/photo-1593618998160-e34014e67546?w=200&h=200&fit=crop', originalPrice: 35000, salePrice: 24500, discount: 30, freeShipping: true, todayDelivery: true },
  { id: 14, name: '주방 타이머', image: 'https://images.unsplash.com/photo-1563861826100-9cb868fdbe1c?w=200&h=200&fit=crop', originalPrice: 15000, salePrice: 9900, discount: 34, freeShipping: true, todayDelivery: false },
  { id: 15, name: '실리콘 냄비받침 4p', image: 'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=200&h=200&fit=crop', originalPrice: 18000, salePrice: 12600, discount: 30, freeShipping: true, todayDelivery: true },
  { id: 16, name: '스텐 국자/뒤집개 세트', image: 'https://images.unsplash.com/photo-1590794056226-79ef3a8147e1?w=200&h=200&fit=crop', originalPrice: 28000, salePrice: 19600, discount: 30, freeShipping: true, todayDelivery: true },
  { id: 17, name: '냉장고 정리용기 6p', image: 'https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=200&h=200&fit=crop', originalPrice: 32000, salePrice: 22400, discount: 30, freeShipping: true, todayDelivery: false },
  { id: 18, name: '양념통 세트 8p', image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=200&h=200&fit=crop', originalPrice: 25000, salePrice: 17500, discount: 30, freeShipping: true, todayDelivery: true },
  { id: 19, name: '행주/수세미 세트', image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=200&h=200&fit=crop', originalPrice: 12000, salePrice: 8400, discount: 30, freeShipping: false, todayDelivery: true },
  { id: 20, name: '주방 저울', image: 'https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=200&h=200&fit=crop', originalPrice: 22000, salePrice: 15400, discount: 30, freeShipping: true, todayDelivery: false }
]);

// 리뷰 (실제 프로필 이미지 사용)
const reviews = ref<Review[]>([
  {
    id: 1,
    name: '김*희',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
    date: '2025.01.18',
    rating: 5,
    product: '프리미엄 스텐 반찬통 10종세트',
    content: '밀폐력이 정말 좋아요! 김치 넣어도 냄새 안새고 냉장고 정리도 깔끔하게 됐어요. 설 선물로 친정엄마께도 하나 더 사드릴 예정이에요 ㅎㅎ',
    helpful: 128
  },
  {
    id: 2,
    name: '박*영',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
    date: '2025.01.17',
    rating: 5,
    product: '테팔 프라이팬 3종세트',
    content: '역시 테팔이네요. 코팅 진짜 좋고 손잡이 분리되는 게 수납할 때 너무 편해요. 가격도 저렴하게 잘 샀어요!',
    helpful: 89
  },
  {
    id: 3,
    name: '이*수',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    date: '2025.01.16',
    rating: 4,
    product: '설날 효도선물 세트 A',
    content: '부모님 선물로 샀는데 포장이 정말 고급스러워요. 받으시고 좋아하셨습니다. 다만 배송이 하루 더 걸렸네요.',
    helpful: 56
  }
]);

// 장바구니
const cart = ref<Product[]>([]);
const showCart = ref(false);

const cartCount = computed(() => cart.value.reduce((sum, item) => sum + (item.quantity || 1), 0));
const cartTotal = computed(() => cart.value.reduce((sum, item) => sum + item.salePrice * (item.quantity || 1), 0));

// 스낵바
const snackbar = ref({
  show: false,
  text: '',
  color: 'success'
});

// 유틸 함수
const formatPrice = (price: number) => {
  return price.toLocaleString('ko-KR') + '원';
};

const addToCart = (product: Product) => {
  const existingItem = cart.value.find(item => item.id === product.id);
  if (existingItem) {
    existingItem.quantity = (existingItem.quantity || 1) + 1;
  } else {
    cart.value.push({ ...product, quantity: 1 });
  }
  snackbar.value = { show: true, text: '장바구니에 추가되었습니다!', color: 'success' };
};

const removeFromCart = (product: Product) => {
  const index = cart.value.findIndex(item => item.id === product.id);
  if (index > -1) {
    cart.value.splice(index, 1);
  }
};

const increaseQuantity = (product: Product) => {
  product.quantity = (product.quantity || 1) + 1;
};

const decreaseQuantity = (product: Product) => {
  if ((product.quantity || 1) > 1) {
    product.quantity = (product.quantity || 1) - 1;
  } else {
    removeFromCart(product);
  }
};

const toggleWishlist = (product: Product) => {
  product.isWishlisted = !product.isWishlisted;
  snackbar.value = {
    show: true,
    text: product.isWishlisted ? '위시리스트에 추가되었습니다!' : '위시리스트에서 제거되었습니다.',
    color: product.isWishlisted ? 'success' : 'info'
  };
};

onMounted(() => {
  updateCountdown();
  countdownInterval = window.setInterval(updateCountdown, 1000);
});

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "promo-banner" }, [
      _createElementVNode("div", { class: "promo-text" }, [
        _createElementVNode("span", { class: "promo-icon" }, "🧧"),
        _createTextVNode(" 설 연휴 특별 할인! 전 상품 "),
        _createElementVNode("strong", null, "최대 50% OFF"),
        _createTextVNode(" + 무료배송 "),
        _createElementVNode("span", { class: "promo-icon" }, "🧧")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "hero-badge" }, [
          _createElementVNode("span", null, "2025 설 특집")
        ], -1)),
        _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "hero-title" }, [
          _createTextVNode(" 새해 복 많이 받으세요! "),
          _createElementVNode("span", { class: "title-deco" }, "🎊")
        ], -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "hero-subtitle" }, [
          _createTextVNode(" 알뜰 주부님들을 위한 특별한 설 선물"),
          _createElementVNode("br"),
          _createTextVNode(" 반찬통 세트부터 주방용품까지 최대 50% 할인 ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "countdown-label" }, "특가 마감까지", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(countdown.value.days), 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "time-label" }, "일", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "time-separator" }, ":", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(countdown.value.hours), 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "time-label" }, "시간", -1))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "time-separator" }, ":", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(countdown.value.minutes), 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "time-label" }, "분", -1))
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "time-separator" }, ":", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(countdown.value.seconds), 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "time-label" }, "초", -1))
            ])
          ])
        ])
      ]),
      _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"hero-decoration\" data-v-6bb98382><div class=\"lantern lantern-1\" data-v-6bb98382>🏮</div><div class=\"lantern lantern-2\" data-v-6bb98382>🏮</div><div class=\"lantern lantern-3\" data-v-6bb98382>🏮</div><div class=\"gold-coin coin-1\" data-v-6bb98382>🪙</div><div class=\"gold-coin coin-2\" data-v-6bb98382>🪙</div><div class=\"plum-blossom blossom-1\" data-v-6bb98382>🌸</div><div class=\"plum-blossom blossom-2\" data-v-6bb98382>🌸</div></div>", 1))
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category.id,
            class: _normalizeClass(['category-item', { active: selectedCategory.value === category.id }]),
            onClick: ($event: any) => (selectedCategory.value = category.id)
          }, [
            _createElementVNode("img", {
              src: category.icon,
              alt: category.name,
              class: "category-icon-img"
            }, null, 8, _hoisted_17),
            _createElementVNode("span", _hoisted_18, _toDisplayString(category.name), 1)
          ], 10, _hoisted_16))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "section-emoji" }, "⚡", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "section-title" }, "오늘의 타임딜", -1)),
          _createVNode(_component_v_chip, {
            color: "error",
            size: "small",
            variant: "flat",
            class: "ml-2"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("HOT", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "section-subtitle" }, "지금 이 가격, 다시 없을 기회!", -1))
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeDealProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.id,
            class: "time-deal-card"
          }, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(product.discount) + "%", 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("img", {
                src: product.image,
                alt: product.name,
                class: "product-img"
              }, null, 8, _hoisted_25)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(product.name), 1),
              _createElementVNode("div", _hoisted_28, _toDisplayString(product.description), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(formatPrice(product.originalPrice)), 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(formatPrice(product.salePrice)), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "progress-fill",
                    style: _normalizeStyle({ width: product.soldPercent + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_34, _toDisplayString(product.soldPercent) + "% 판매", 1)
              ])
            ]),
            _createVNode(_component_v_btn, {
              color: "error",
              variant: "flat",
              block: "",
              class: "buy-btn",
              onClick: ($event: any) => (addToCart(product))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  start: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("mdi-cart", -1)
                  ]))]),
                  _: 1
                }),
                _cache[21] || (_cache[21] = _createTextVNode(" 바로구매 ", -1))
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_35, [
      _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"section-header\" data-v-6bb98382><div class=\"section-title-wrapper\" data-v-6bb98382><span class=\"section-emoji\" data-v-6bb98382>👑</span><h2 class=\"section-title\" data-v-6bb98382>베스트셀러</h2></div><p class=\"section-subtitle\" data-v-6bb98382>주부님들이 가장 많이 찾는 인기 상품</p></div>", 1)),
      _createElementVNode("div", _hoisted_36, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bestProducts.value, (product, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.id,
            class: "product-card"
          }, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(index + 1), 1),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("img", {
                src: product.image,
                alt: product.name,
                class: "product-img-large"
              }, null, 8, _hoisted_39),
              _createElementVNode("div", _hoisted_40, [
                (product.isNew)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "NEW"))
                  : _createCommentVNode("", true),
                (product.isBest)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "BEST"))
                  : _createCommentVNode("", true),
                (product.discount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(product.discount) + "%", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "wishlist-btn",
                onClick: ($event: any) => (toggleWishlist(product))
              }, [
                _createVNode(_component_v_icon, {
                  color: product.isWishlisted ? 'error' : 'grey'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(product.isWishlisted ? 'mdi-heart' : 'mdi-heart-outline'), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ], 8, _hoisted_44)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(product.brand), 1),
              _createElementVNode("div", _hoisted_47, _toDisplayString(product.name), 1),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createVNode(_component_v_icon, {
                      key: n,
                      size: "14",
                      color: n <= product.rating ? 'amber' : 'grey-lighten-2'
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode(" mdi-star ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  }), 64))
                ]),
                _createElementVNode("span", _hoisted_50, "(" + _toDisplayString(product.reviews) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                (product.discount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(formatPrice(product.originalPrice)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_53, _toDisplayString(formatPrice(product.salePrice)), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                (product.freeShipping)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, "무료배송"))
                  : _createCommentVNode("", true),
                (product.giftAvailable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, "선물포장"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              block: "",
              class: "add-cart-btn",
              onClick: ($event: any) => (addToCart(product))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  start: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("mdi-cart-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createTextVNode(" 장바구니 담기 ", -1))
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_57, [
      _cache[27] || (_cache[27] = _createStaticVNode("<div class=\"gift-banner\" data-v-6bb98382><div class=\"gift-content\" data-v-6bb98382><div class=\"gift-badge\" data-v-6bb98382>🎁 설 선물 세트</div><h2 class=\"gift-title\" data-v-6bb98382>소중한 분께 마음을 전하세요</h2><p class=\"gift-subtitle\" data-v-6bb98382>정성이 담긴 선물세트, 무료 포장 서비스 제공</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_58, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(giftSets.value, (gift) => {
          return (_openBlock(), _createElementBlock("div", {
            key: gift.id,
            class: "gift-card"
          }, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("img", {
                src: gift.image,
                alt: gift.name,
                class: "gift-img"
              }, null, 8, _hoisted_60)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, _toDisplayString(gift.name), 1),
              _createElementVNode("div", _hoisted_63, _toDisplayString(gift.description), 1),
              _createElementVNode("div", _hoisted_64, _toDisplayString(formatPrice(gift.price)), 1),
              _createElementVNode("div", _hoisted_65, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gift.includes, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "include-item"
                  }, _toDisplayString(item), 1))
                }), 128))
              ])
            ]),
            _createVNode(_component_v_btn, {
              color: "error",
              variant: "outlined",
              block: "",
              class: "gift-btn",
              onClick: ($event: any) => (addToCart(gift))
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode(" 선물하기 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_66, [
      _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"section-header\" data-v-6bb98382><div class=\"section-title-wrapper\" data-v-6bb98382><span class=\"section-emoji\" data-v-6bb98382>💝</span><h2 class=\"section-title\" data-v-6bb98382>주부님들의 Pick</h2></div><p class=\"section-subtitle\" data-v-6bb98382>실용적이고 알뜰한 생활용품 모음</p></div>", 1)),
      _createElementVNode("div", _hoisted_67, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.id,
            class: "recommend-card"
          }, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("img", {
                src: product.image,
                alt: product.name,
                class: "recommend-img"
              }, null, 8, _hoisted_69),
              (product.discount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, "-" + _toDisplayString(product.discount) + "%", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, _toDisplayString(product.name), 1),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("span", _hoisted_74, _toDisplayString(formatPrice(product.salePrice)), 1),
                (product.discount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(formatPrice(product.originalPrice)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_76, [
                (product.freeShipping)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "x-small",
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                        _createTextVNode("무료배송", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (product.todayDelivery)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      size: "x-small",
                      color: "success",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode("오늘출발", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_77, [
      _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"section-header\" data-v-6bb98382><div class=\"section-title-wrapper\" data-v-6bb98382><span class=\"section-emoji\" data-v-6bb98382>💬</span><h2 class=\"section-title\" data-v-6bb98382>고객 후기</h2></div><p class=\"section-subtitle\" data-v-6bb98382>실제 구매 고객님들의 생생한 후기</p></div>", 1)),
      _createElementVNode("div", _hoisted_78, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (review) => {
          return (_openBlock(), _createElementBlock("div", {
            key: review.id,
            class: "review-card"
          }, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("img", {
                src: review.avatar,
                alt: review.name,
                class: "reviewer-avatar-img"
              }, null, 8, _hoisted_80),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, _toDisplayString(review.name), 1),
                _createElementVNode("div", _hoisted_83, _toDisplayString(review.date), 1)
              ]),
              _createElementVNode("div", _hoisted_84, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_component_v_icon, {
                    key: n,
                    size: "14",
                    color: n <= review.rating ? 'amber' : 'grey-lighten-2'
                  }, {
                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                      _createTextVNode(" mdi-star ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_85, _toDisplayString(review.product), 1),
            _createElementVNode("div", _hoisted_86, _toDisplayString(review.content), 1),
            _createElementVNode("div", _hoisted_87, [
              _createVNode(_component_v_btn, {
                size: "small",
                variant: "text",
                color: "grey"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                      _createTextVNode("mdi-thumb-up-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" 도움이 돼요 (" + _toDisplayString(review.helpful) + ") ", 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_88, [
      _createElementVNode("div", _hoisted_89, [
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "banner-text" }, [
          _createElementVNode("h3", null, "설 연휴에도 배송됩니다!"),
          _createElementVNode("p", null, "1월 27일까지 주문 시 설 전 배송 보장")
        ], -1)),
        _createVNode(_component_v_btn, {
          color: "white",
          variant: "flat",
          size: "large",
          class: "banner-btn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode("mdi-truck-fast", -1)
              ]))]),
              _: 1
            }),
            _cache[35] || (_cache[35] = _createTextVNode(" 배송일정 확인 ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: "cart-float",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showCart.value = true))
    }, [
      _createVNode(_component_v_badge, {
        content: cartCount.value,
        color: "error",
        "model-value": cartCount.value > 0
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            color: "primary",
            size: "large",
            elevation: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                  _createTextVNode("mdi-cart", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["content", "model-value"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showCart.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showCart).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "cart-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "cart-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-cart", -1)
                  ]))]),
                  _: 1
                }),
                _cache[40] || (_cache[40] = _createTextVNode(" 장바구니 ", -1)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showCart.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (cart.value.length > 0)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "cart-content"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "cart-item"
                      }, [
                        _createElementVNode("img", {
                          src: item.image,
                          alt: item.name,
                          class: "cart-item-img"
                        }, null, 8, _hoisted_90),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_93, _toDisplayString(formatPrice(item.salePrice)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(_component_v_btn, {
                            icon: "",
                            size: "x-small",
                            variant: "outlined",
                            onClick: ($event: any) => (decreaseQuantity(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                  _createTextVNode("mdi-minus", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("span", _hoisted_95, _toDisplayString(item.quantity), 1),
                          _createVNode(_component_v_btn, {
                            icon: "",
                            size: "x-small",
                            variant: "outlined",
                            onClick: ($event: any) => (increaseQuantity(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createTextVNode("mdi-plus", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          color: "grey",
                          variant: "text",
                          onClick: ($event: any) => (removeFromCart(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                _createTextVNode("mdi-delete", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 1,
                  class: "cart-empty"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "64",
                      color: "grey-lighten-2"
                    }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-cart-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createElementVNode("p", null, "장바구니가 비어있습니다", -1))
                  ]),
                  _: 1
                })),
            _createVNode(_component_v_divider),
            (cart.value.length > 0)
              ? (_openBlock(), _createBlock(_component_v_card_actions, {
                  key: 2,
                  class: "cart-actions"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_96, [
                      _cache[46] || (_cache[46] = _createElementVNode("span", null, "총 결제금액", -1)),
                      _createElementVNode("span", _hoisted_97, _toDisplayString(formatPrice(cartTotal.value)), 1)
                    ]),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      variant: "flat",
                      block: "",
                      size: "large",
                      class: "checkout-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("mdi-credit-card", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[48] || (_cache[48] = _createTextVNode(" 결제하기 ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 2000,
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.text), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})